import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {ResourceUsages} from "../resources/types";
import {RESOURCE_USAGES_QUERY_KEY} from "../queryKeys";

type Variables = {assetIds: number[]};

export type AssetsUsages = Record<number, ResourceUsages>;

const getAssetsUsages = async ({assetIds}: Variables): Promise<AssetsUsages> => {
  const response = await axiosReachInstance.post<AssetsUsages, AxiosResponse<AssetsUsages>>("/assets/usages", {
    asset_ids: assetIds,
  });
  return response.data;
};

export const useGetAssetsUsages = (
  variables: Variables,
  options?: BaseQueryOptions<AssetsUsages, Variables>
): BaseUseQueryResult<AssetsUsages> => {
  return useBaseQuery<AssetsUsages, Variables>(
    [RESOURCE_USAGES_QUERY_KEY, "assets", ...variables.assetIds],
    getAssetsUsages,
    variables,
    {refetchOnMount: "always", ...options}
  );
};
